import { render, staticRenderFns } from "./SBArtistListTitle.html?vue&type=template&id=91824164&scoped=true&"
import script from "./SBArtistListTitle.ts?vue&type=script&lang=ts&"
export * from "./SBArtistListTitle.ts?vue&type=script&lang=ts&"
import style0 from "./SBArtistListTitle.css?vue&type=style&index=0&id=91824164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91824164",
  null
  
)

export default component.exports